export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-star-838e96f3d3803dbdc2db18cb50e4134e.svg";